import { Interface } from '@ethersproject/abi'
import FARMS_REWARD_POOL_ABI from './farms-reward-pool.json'
import FARMS_MULTI_REWARD_POOL_ABI from './farms-multi-reward.json'

const REWARD_POOL_INTERFACE = new Interface(FARMS_REWARD_POOL_ABI)
const MULTI_REWARD_POOL_INTERFACE = new Interface(FARMS_MULTI_REWARD_POOL_ABI)

export default REWARD_POOL_INTERFACE
export { MULTI_REWARD_POOL_INTERFACE, FARMS_REWARD_POOL_ABI, FARMS_MULTI_REWARD_POOL_ABI }
